export default {
  workorderinfo: '/workorder/selectworkorderinfo/', //获取工单详情
  getWorkOrderInfo: '/workorder/selectworkorderlog/{id}', //获取工单日志
  workorderpage: '/workorder/workorderpage', //获取工单列表
  saveworkorder: '/workorder/saveworkorder', //保存工单信息
  selectservice: '/workorder/selectservicebycustomer', //根据客户信息获取服务单信息
  operation: '/workorder/operationworkorder', //操作工单状态
  domainbyservice: '/workorder/domainbyservice', //根据服务单信息获取域名
  addremarks: '/workorder/addremarks', //添加备注
  handlestatus: '/enum/gethandlestatusenum', //处理状态枚举
  problemtype: '/enum/getproblemtypeenum', //问题类型枚举
  workordertype: '/enum/getworkordertypeenum', // 工单类型枚举
  addRemarks: '/workorder/addremarks' //工单详情页添加备注信息
}
